"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchBranches = fetchBranches;
const webappApi_1 = require("./webappApi");
const branch_1 = require("./parser/branch");
const route = "branches";
async function fetchBranches(params) {
    const p = new URLSearchParams();
    if (params.groupId) {
        p.append('groupID', params.groupId.toString());
    }
    const res = await (0, webappApi_1.makeGetRequest)(`${route}?${p.toString()}`);
    const apiResponse = await res.json();
    const branches = [];
    apiResponse.data.forEach((b) => {
        const branch = (0, branch_1.parseBranchFromApi)(b);
        branches.push(branch);
    });
    const out = {
        branches: branches,
        pagination: apiResponse.pagination,
    };
    return out;
}
